import React from 'react';
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';

export const Organizer = () => (
  <div>
    <Helmet>
      <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - International Committee</title>
    </Helmet>
      <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
        <li class="breadcrumb-item"><a href="/">Committee</a></li>
        <li class="breadcrumb-item active" aria-current="page">International Scientific Committee</li>
      </ol>
    </nav>
    <h2>International Scientific Committee</h2> <br/>
    <p>
      <b>•	Professor Nur Iriawan, Ph.D <br/> </b>
      Institut Teknologi Sepuluh Nopember, Indonesia <br/>
    </p>

    <p>
      <b>•  Professor Dr Mario Köppen  <br/> </b>
      Kyutech Institute of Technology, Japan <br/>
    </p>

    <p> 
      <b>•	Professor Dr. Sri Hartati <br/> </b>
      Universitas Gadjah Mada, Indonesia <br/>
    </p>

    <p> 
      <b>•	Professor Dr Chidchanok Lursinsap <br/> </b>
      Chulalongkorn University, Thailand <br/>
    </p>

    <p>
      <b>•	Professor Dr. Hizir Sofyan <br/> </b>
      Syiah Kuala University, Indonesia <br/>
    </p>

    <p>
      <b>•	Associate Professor Dr Aiden Doherty <br/> </b>
      Oxford University, UK <br/>
    </p>

    <p>
      <b>•	Professor Dr Layth Sliman <br/> </b>
      Efrei, Paris, France <br/>
    </p>

    <p>
      <b>•	Assistant Professor Dr Ubydul Haque <br/> </b>
      Universiti of North Texas Health Care Centre, USA <br/>
    </p>

    <p>
      <b>•	Professor Dr Ruhana Ku Mahamud <br/> </b>
      Universiti Utara Malaysia, Malaysia <br/>
    </p>

    <p>
      <b>•	Associate Professor Dr. Rajalida Lipikorn <br/></b>
      Chulalongkorn University, Thailand <br/>
    </p>

    <p>
      <b>•	Associate Professor Dr. Agus Harjoko <br/></b>
      Universitas Gadjah Mada, Indonesia <br/>
    </p>

    <p>
      <b>•	Professor Dr. Min Chen <br/></b>
      University of Oxford, England <br/>
    </p>

    <p>
      <b>•	Associate Professor Dr. Simon Fong <br/></b>
      University of Macau, China   <br/>
    </p>
    <p>
      <b>•  Professor Dr. Richard Millham <br/></b>
      Durban University of Technology, South Africa <br/>
    </p>

    <p>
      <b>•	Professor Dr. Mohammed Bennamoun  <br/></b>
      University of Western Australia, Australia  <br/>
    </p>

    <p>
      <b>•	Associate Professor Dr. Adel Al-Jumaily <br/></b>
      Charles Sturt University, Australia   <br/>
    </p>

    <p>
      <b>•	Associate Professor Dr. Yasue Mitsukura   <br/></b>
      Keio University, Japan  <br/>
    </p>

    <p>
      <b>•	Professor Dr. Dhiya Al-Jumeily  <br/></b>
       Liverpool John Moores University, UK  <br/>
    </p>

    <p>
      <b>•	Professor Dr. Dariusz Krol  <br/></b>
      Wroclaw University of Poland, Poland  <br/>
    </p>

    <p>
      <b>•	Professor Dr. Richard Weber  <br/></b>
      University of Chile, Santiago, Chile  <br/>
    </p>

    <p>
      <b>•	Professor Dr. Jose Maria Pena  <br/></b>
      Technical University of Madrid, Madrid, Spain  <br/>
    </p>

    <p>
      <b>•	Associate Professor Yusuke Nojima  <br/></b>
      Osaka Perfecture University, Japan  <br/>
    </p>

    <p>
      <b>•	Dr. Siddhivinayak Kulkarni  <br/></b>
      Universiti of Ballarat, Australia  <br/>
    </p>

    <p>
      <b>•	Professor Dr. Tahir Ahmad  <br/></b>
      Universiti Teknologi Malaysia, Malaysia  <br/>
    </p>

    <p>
      <b>•	Professor Dr. Daud Mohamed  <br/></b>
      Universiti Teknologi MARA, Malaysia  <br/>
    </p>

    <p>
      <b>•	Associate Professor Dr. Wahyu Wibowo <br/></b>
      Insititut Teknologi Sepuluh Nopember, Surabaya, Indonesia <br/>
    </p>

    <p>
      <b>•	Associate Professor Dr. Edi Winarko <br/></b>
      Universitas Gadjah Mada, Indonesia <br/>
    </p>

    <p>
      <b>•	Associate Professor  Dr. Retantyo Wardoyo <br/></b>
      Universitas Gadjah Mada, Indonesia <br/>
    </p>

    <p>
      <b>•	Associate Professor Dr. Rayner Alfred <br/></b>
      University Malaysia Sabah, Malaysia <br/>
    </p>

    <p>
      <b>•	Associate Professor Dr Faiz Ahmed Mohamed Elfaki <br/></b>
      Qatar University, Qatar <br/>
    </p>

    <p>
      <b>•	Associate Professor Dr Mohamed Chaouch <br/></b>
      Qatar University, Qatar <br/>
    </p>

    <p>
      <b>•	Dr. Abdul Haris Rangkuti, S.Kom., M.M., M.Si. <br/></b>
      BINUS University, Indonesia <br/>
    </p>

    <p>
      <b>•	Dr. Sapto Wahyu Indratno <br/></b>
      Institut Teknologi Bandung, Indonesia <br/>
    </p>

    <p>
      <b>•	Ms Angela Kim <br/></b>
      Head of Women in AI, Asia Pacific <br/>
    </p>

  </div>
)